import { useTranslation } from "react-i18next";
import PiBrowseDialog from "../../components/PiBrowseDialog";
import { AssetDetailsDTO, AssetKey } from "../../dto/AssetDTO";
import { useScopeTypeName } from "./AssetScopeNotice";
import FileExplorerBody from "./FileExplorerBody";
import "./FileExplorerDialog.css";

interface FileExplorerDialogProps {
  open: boolean;
  onClose: () => void;
  type?: AssetKey;
  onSelect?: (id: AssetDetailsDTO) => void;
  allowMultiSelect?: boolean;
  onMultiSelect?: (assets: AssetDetailsDTO[]) => void;
}

export default function FileExplorerDialog(props: FileExplorerDialogProps) {
  const { open, onClose, type, onSelect, allowMultiSelect, onMultiSelect } =
    props;
  const { t } = useTranslation();

  // Replaces the old "| image" title suffix. Phrased "Only images" rather
  // than "Images only" so the type is never sentence-initial — the plural
  // noun is interpolated, and four of the five languages put it elsewhere in
  // the sentence anyway.
  const typeName = useScopeTypeName();
  const scopeBadge =
    type !== undefined ? (
      <span
        className="px-[10px] py-[3px] rounded-full border border-creator-primary bg-creator-primary-washed text-[11px] leading-[14px] font-medium text-creator-text-key"
        data-testid="file-explorer-scope-badge"
      >
        {t("file_explorer_ui.scope_badge", { types: typeName(type) })}
      </span>
    ) : undefined;

  return (
    <PiBrowseDialog
      open={open}
      onClose={onClose}
      title={t("fileExplorer")}
      scopeBadge={scopeBadge}
      body={
        <FileExplorerBody
          onClose={onClose}
          type={type}
          onSelect={onSelect}
          allowMultiSelect={allowMultiSelect}
          onMultiSelect={onMultiSelect}
        />
      }
    />
  );
}
